import React from "react";
import Navbar from "../../globals/components/Navbar";
import PremiumCalculatorBase from "./PremiumCalculatorBase";

const PremiumCalculator = () => (
  <PremiumCalculatorBase variant="authenticated" header={<Navbar />} />
);

export default PremiumCalculator;
